/** @jsx jsx */
import { ArrowBackIcon, Box, Button } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { useApplyWizard } from "./ApplyWizardContext";

interface ApplyWizardBackButtonProps {}

export const ApplyWizardBackButton: FC<ApplyWizardBackButtonProps> = ({}) => {
  const { t } = useTranslation("session");

  const { currentStepIndex, goToPrevStep, steps } = useApplyWizard();

  if (currentStepIndex === 0) {
    return null;
  }

  return (
    <Box sx={{ display: ["none", null, null, "block"] }}>
      <Button iconLeft={<ArrowBackIcon />} size="sm" variant="ghost" onClick={goToPrevStep}>
        {t(`JOB_REQUESTS.APPLY.WIZARD.BACK_TO_${steps[currentStepIndex - 1].key}`)}
      </Button>
    </Box>
  );
};
